
<script setup lang="ts">
import DropdownComponent from '../components/dropdown/DropdownComponent.vue';
import DropdownTrigger from '../components/dropdown/DropdownTrigger.vue';
import DropdownBody from '../components/dropdown/DropdownBody.vue';

import { Button } from '@albank/vue-ui-kit';
import { inject } from 'vue'

const view = inject("view", "mobile")
</script>

<template>
  <section class="screen screen-container banner-screen">
    <div class="banner">
      <div class="banner__content">
        <div class="banner__text">
          <h2>Мобильное приложение <br />«АЭБ Онлайн»</h2>
          <p>Управляйте своими финансами где угодно и в любое время</p>
        </div>
        <img 
          v-if="view == 'mobile'"
          src="/assets/images/app-mobile.png" 
          alt="app" class="banner__img"
        >
        <div class="banner__links">
          <div class="banner__links-row">
            <DropdownComponent>
              <DropdownTrigger>
                <Button 
                  :icon-source="{left: '/assets/icons/QR.svg'}"
                  :left-icon="true" 
                  class="button light-button"
                >Скачать</Button>
              </DropdownTrigger>
              <DropdownBody>
                <h3>Мобильное приложение</h3>
                <p>Наведите камеру телефона на QR-код и скачайте приложение</p>
                <img src="/assets/images/qr-code.png" alt="">
              </DropdownBody>
            </DropdownComponent>
            
          </div>

          <a href="https://apps.apple.com/ru/app/%D0%B0%D1%8D%D0%B1-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-2-0/id1278796871">
            <Button 
              :icon-source="{left: '/assets/icons/apple-store.png'}"
              :left-icon="true" class="button dark-button"
            />
          </a>
          
          <a href="https://play.google.com/store/apps/details?id=ru.albank.online.aebit&hl=ru">
            <Button 
              :icon-source="{left: '/assets/icons/google-play.png'}"
              :left-icon="true" class="button dark-button"
            />
          </a>

          <a href="https://appgallery.huawei.com/#/app/C104494399">
            <Button 
              :icon-source="{left: '/assets/icons/huawei-store.png'}"
              :left-icon="true" class="button dark-button"
            />
          </a>

          <a href="https://www.rustore.ru/catalog/app/ru.albank.online.aebit">
            <Button 
              :icon-source="{left: '/assets/icons/ru-store.png'}"
              :left-icon="true" class="button dark-button"
            />
          </a>
          
        </div>
      </div>
      <img 
        v-if="view != 'mobile'"
        src="/assets/images/app.png" 
        alt="app" class="banner__img"
      >
    </div>
  </section>
</template>


<style lang="scss">
.banner-screen {
  width: 100%;
  margin-top: 120px;
}

.banner {
  width: 100%;
  display: flex;  
  height: 300px;
  padding: 40px;
  position: relative;
  border-radius: 32px;
  background: var(--color-green-50);

  @media screen and (max-width: 1140px) {
    height: auto;
  }

  h2 {
    text-align: left;
    font-size: var(--font-size-lm);

    @media screen and (max-width: 1140px) {    
      font-size: var(--font-size-l);
    }
  }

  @media screen and (max-width: 800px) {
    height: auto;
    background: #D9F7F0;
    flex-direction: column;

    h2 {
      text-align: center;
    }

    p {
      font-size: var(--font-size-xs);  
    }
  }

  @media screen and (max-width: 800px) {
    height: auto;
    flex-direction: column;

    p {
      font-size: var(--font-size-xs);  
    }
  }

  &__content {
    gap: 30px;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media screen and (max-width: 1140px) {
      gap: 20px;
      justify-content: flex-start;
    }

    @media screen and (max-width: 800px) {
      width: 100%;
      text-align: center;
      align-items: center;
    }  
  }

  &__text {
    p {
      margin-top: 20px;
      font-size: var(--font-size-m);
    }
  }

  &__links {
    gap: 10px;
    display: flex;

    @media screen and (max-width: 800px) {
      gap: 16px;
      flex-wrap: wrap;
      justify-content: center;
    
      &-row {
        width: 100%;
        display: flex;
        justify-content: center;
      }
    }  
  }

  &__img {
    bottom: 0;
    right: 0;
    max-width: 50%;
    max-height: 100%;
    position: absolute;

    @media screen and (max-width: 800px) {    
      max-width: 100%;
      position: relative;
    }
  }
}
</style>
